import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import { PublicWebsiteNavContainer } from '../PublicWebsiteNav/PublicWebsiteNavContainer';
import { isEmbedPath, isRWFPath } from '../../../helpers/serverRenderingUtils';
import {
  getScreenFromRoute,
  initializeBraze,
  initializeMParticle,
  initializeWithUser,
} from '../../modules/analytics';
import { editorPaths } from '../../utils';
import Link from '../Link';
import ScrollToTop from '../ScrollToTop';
import styles from './styles.sass';
import { JumpToContent } from './styles';

class App extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleLogOut = this.handleLogOut.bind(this);
    this.handleClickLogIn = this.handleClickLogIn.bind(this);
    this.handleClickAccountMenu = this.handleClickAccountMenu.bind(this);
    this.state = {
      didFetchPodcastStatus: false,
      didInitializeAnalytics: false,
    };
  }

  componentDidMount() {
    const {
      location,
      actions: { fetchGeoRegion, fetchPodcastAndSet },
      compliance: { isSessionRetrieved, geoRegion, geoCountry },
      isLoggedIn,
    } = this.props;

    this.fetchPodcastStatus();
    if (isLoggedIn) fetchPodcastAndSet();
    // Send initial page view for app startup
    this.handleRouteChange(location);
    // geo-detection
    if (isSessionRetrieved && (!geoRegion || !geoCountry)) {
      fetchGeoRegion();
    }
  }

  componentDidUpdate(prevProps) {
    const { location, user } = this.props;
    const { isSessionRetrieved, geoCountry, geoRegion } = this.props.compliance;
    const { didInitializeAnalytics } = this.state;
    // analytics
    if (!didInitializeAnalytics && getScreenFromRoute(location.pathname)) {
      if (window.__MPARTICLE_API_KEY__) {
        initializeMParticle(window.__MPARTICLE_API_KEY__).then(() =>
          initializeWithUser(user)
        );
      }
      if (window.__BRAZE_API_KEY__) {
        initializeBraze(window.__BRAZE_API_KEY__);
      }
      this.setState(() => ({
        didInitializeAnalytics: true,
      }));
    }
    // switching accounts, edge case
    if (this.props.user !== prevProps.user) {
      this.setState({
        didFetchPodcastStatus: false,
      });
      return; // fetch on next update
    }
    if (prevProps.location && this.props.location !== prevProps.location) {
      this.handleRouteChange(this.props.location, prevProps.location);
    }
    if (
      isSessionRetrieved &&
      isSessionRetrieved !== prevProps.compliance.isSessionRetrieved &&
      (!geoRegion || !geoCountry)
    ) {
      this.props.actions.fetchGeoRegion();
    }
    this.fetchPodcastStatus();
  }

  fetchPodcastStatus() {
    const { didFetchPodcastStatus } = this.state;
    const {
      actions: { fetchMyPodcastStatus, fetchMyPodcastImportStatus },
      isLoggedIn,
    } = this.props;
    // just authenticated / logged in as a new user
    if (isLoggedIn && !didFetchPodcastStatus) {
      this.setState({
        didFetchPodcastStatus: true,
      });
      fetchMyPodcastStatus().then((response = {}) => {
        if (response.podcastExternalSource) {
          // then check if external podcast, confirm status of import
          fetchMyPodcastImportStatus();
        }
      });
    }
  }

  handleLogOut(evt) {
    evt.preventDefault();
    const { clickAccount, requestToLogOutUser } = this.props.actions;
    evt.preventDefault();
    clickAccount('Log Out');
    requestToLogOutUser();
  }

  handleClickLogIn() {
    const { clickAccount } = this.props.actions;
    clickAccount('Log In');
  }

  handleClickAccountMenu() {
    const { clickAccount } = this.props.actions;
    clickAccount('Account Menu');
  }

  // For general state cleanup on client-side route changes
  // TODO: how to delegate this to reducers? But we cannot dispatch from a reducer, that is impure
  handleRouteChange(currentLocation, previousLocation) {
    const {
      actions: { dispatchPageTransitionAction, stopEditorAudio },
    } = this.props;
    dispatchPageTransitionAction(currentLocation);

    if (!previousLocation) {
      return;
    }

    if (
      (!currentLocation.pathname.match(editorPaths.editEpisodePattern) ||
        !previousLocation.pathname.match(editorPaths.editEpisodePattern)) &&
      (currentLocation.pathname.indexOf(editorPaths.newEpisodeBasePath) !== 0 ||
        previousLocation.pathname.indexOf(editorPaths.newEpisodeBasePath) !== 0)
    ) {
      stopEditorAudio();
    }
  }

  render() {
    const {
      campaigns,
      compliance,
      context,
      isAllowedToSeeMoneyNavItem,
      isEuropeanGeoRegion,
      location,
      user,
      shareLinkPath,
      podcastNetwork,
      onDismissCookieBanner,
      onClickNavItem,
      podcastName,
      podcastImage,
    } = this.props;
    return (
      <ScrollToTop>
        <JumpToContent href="#app-content">Skip to main content</JumpToContent>
        <div>
          {!isEmbedPath(location.pathname) && !isRWFPath(location.pathname) && (
            <PublicWebsiteNavContainer
              pathname={location.pathname}
              isAllowedToSeeMoneyNavItem={isAllowedToSeeMoneyNavItem}
              user={user}
              onLogOut={this.handleLogOut}
              shareLinkPath={shareLinkPath}
              podcastNetwork={podcastNetwork}
              onClickNavItem={onClickNavItem}
              campaigns={campaigns}
              podcastName={podcastName}
              podcastImage={podcastImage}
            />
          )}
          <div className={styles.appChildrenContainer} id="app-content">
            {renderRoutes(this.props.route.routes, { context })}
          </div>
          {!isEmbedPath(location.pathname) &&
          isEuropeanGeoRegion &&
          !compliance.isCookieBannerDismissed ? (
            <div className="cookieBanner">
              This website uses cookies to understand your use of our website
              and give you a better experience. By continuing to use the site or
              closing this banner, you agree to our use of cookies. To find out
              more about cookies and how to change your choices, please go to
              our <Link to="/privacy">Privacy Policy</Link>.
              <div className="closeIcon" onClick={onDismissCookieBanner}>
                &times;
              </div>
            </div>
          ) : null}
        </div>
      </ScrollToTop>
    );
  }
}

export default App;
